import { ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router";
import "./App.css";
import { GlobalContextProvider } from "./components/GlobalContext/GlobalContext";
import { Router } from "./components/Router/router";
import { theme } from "./theme";

const App = () => {
  return (
    <GlobalContextProvider>
      <ThemeProvider theme={theme}>
        <RouterProvider router={Router} />
      </ThemeProvider>
    </GlobalContextProvider>
  );
};

export default App;
